import { BookingCart } from "./BookingCart";
import { LoyaltyUser } from "./LoyaltyUser";
import { Storage } from "./Storage";
import { Reservation } from "./Reservation";
import constants from "../../../utils/constants";
export class Heartbeat {
    static isValidToSendHeartbeat(data) {
        const bookingCartNotEmpty = !BookingCart.isEmpty();
        const heartbeatDataChanged = Heartbeat.isDirty();
        const isGuestLoyaltyUser = data.loyaltyUser.isValid();
        return bookingCartNotEmpty && heartbeatDataChanged && isGuestLoyaltyUser;
    }
    static getLastReservationSent() {
        return Storage.fromLocalStorage(constants.LOCAL_STORAGE_KEYS.HEARTBEAT_LAST_BOOKING_CART_DATA);
    }
    static isDirty() {
        if (!Heartbeat.getLastReservationSent()) {
            return true;
        }
        const bookingCartReservationAsComparableString = BookingCart.getReservationsAsComparableString();
        const lastReservationSentAsComparableString = Heartbeat.getLastReservationSentAsComparableString();
        return bookingCartReservationAsComparableString !== lastReservationSentAsComparableString;
    }
    static getLoyaltyStoredData() {
        return Object.assign(Object.assign({}, Storage.fromSessionStorage(constants.LOCAL_STORAGE_KEYS.HEARTBEAT_LOYALTY_DATA)), { sessionId: Storage.fromLocalStorage(constants.LOCAL_STORAGE_KEYS.SESSION_ID) });
    }
    static toDto(locale, loyaltyData, searchQueryParams) {
        return {
            locale,
            loyaltyUser: LoyaltyUser.of(loyaltyData),
            bookingCart: BookingCart.getReservations(),
            urlParams: {
                affiliate: searchQueryParams.get("affiliate"),
                origin: searchQueryParams.get("origin"),
            },
        };
    }
    static getLastReservationSentAsComparableString() {
        const bookingReservations = this.getLastReservationSent();
        if (bookingReservations) {
            return Reservation.getAsString(bookingReservations);
        }
    }
}
